module.exports = __webpack_public_path__ + "img/关于我们3.8cadd4a0.png";